import { motion } from 'framer-motion';
import { useMemo } from 'react';
import type { HTMLMotionProps } from 'framer-motion';
import { buildRouteRevealVariants, useYstReducedMotion } from './ystMotion';

type YstRouteTransitionProps = HTMLMotionProps<'div'>;

export const YstRouteTransition = ({
  children,
  initial,
  animate,
  exit,
  ...props
}: YstRouteTransitionProps) => {
  const reducedMotion = useYstReducedMotion();
  const variants = useMemo(
    () => buildRouteRevealVariants(reducedMotion),
    [reducedMotion],
  );

  return (
    <motion.div
      initial={initial ?? 'hidden'}
      animate={animate ?? 'visible'}
      exit={exit ?? 'exit'}
      variants={variants}
      {...props}
    >
      {children}
    </motion.div>
  );
};
